// extracted by mini-css-extract-plugin
export default {"image-box":"ImageBox_image-box__eUN1F"};